import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAgeGroups } from '../store/slices/ageGroupsSlice';

export const useAgeGroups = (branchId) => {
  const dispatch = useDispatch();
  const [ageGroups, setAgeGroups] = useState([]);
  const { loading } = useSelector((state) => state.ageGroups);

  const fetchAgeGroups = () => {
    if (!branchId) {
      setAgeGroups([]);
      return;
    }
    
    dispatch(getAgeGroups(branchId)).unwrap()
      .then((data) => {
        setAgeGroups(data?.items || data || []);
      })
      .catch(() => {
        setAgeGroups([]);
      });
  };

  useEffect(() => {
    fetchAgeGroups();
  }, [dispatch, branchId]);

  return {
    ageGroups,
    loading,
    refetchAgeGroups: fetchAgeGroups
  };
}; 